import { render, staticRenderFns } from "./ProgressSection.vue?vue&type=template&id=445f64fa&scoped=true"
import script from "./ProgressSection.vue?vue&type=script&lang=js"
export * from "./ProgressSection.vue?vue&type=script&lang=js"
import style0 from "./ProgressSection.vue?vue&type=style&index=0&id=445f64fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445f64fa",
  null
  
)

export default component.exports